import actions from './actions'
import generalActions from '../general/actions'

const initialState = {
  loading: false,
  userId: '',
  invitor: '',
  registeredCompanyName: '',
  percentageOfShares: '',
  isCountriesFetched: false,
  countries: [],
  companyName: '',
  userInformation: {},
  frontPageDocument: '',
  backPageDocument: '',
  selfie: '',
  selectedDocType: {},

  // error or warning
  isWarningExist: true,
  warningMessage: 'Loading wait...',
  screeningStatus: 'info',
  screeningResults: 'Loading wait...',
}

export default function idvScreening(state = initialState, action) {
  switch (action.type) {
    case actions.SCREENING_GET_USER_INFROMATION:
      return {
        ...state,
        loading: true,
        userId: action.value,
        isWarningExist: true,
      }
    case actions.SCREENING_GET_USER_INFROMATION_SUCCESS: {
      const response =
        action.value !== undefined && Object.entries(action.value).length > 0 && action.value
      return {
        ...state,
        isWarningExist: false,
        loading: false,
        invitor: response.invitor !== undefined && response.invitor,
        registeredCompanyName:
          response.registeredCompanyName !== undefined && response.registeredCompanyName,
        percentageOfShares:
          response.percentageOfShares !== undefined && response.percentageOfShares,
      }
    }
    case actions.SCREENING_GET_USER_INFROMATION_FAILURE:
      return {
        ...state,
        loading: false,
        isWarningExist: true,
        warningMessage: action.value,
      }
    case generalActions.GET_COUNTRIES:
      return {
        ...state,
        loading: true,
      }
    case generalActions.GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        countries: action.value,
        isCountriesFetched: !state.isCountriesFetched,
      }
    case generalActions.GET_COUNTRIES_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case actions.SCREENING_UPDATE_USER_GENERAL_INFORMATION:
      return {
        ...state,
        frontPageDocument: '',
        backPageDocument: '',
        userInformation: action.value,
      }
    case actions.SCREENING_UPDATE_FRONT_PAGE_DOCUMENT:
      return {
        ...state,
        frontPageDocument: action.value,
      }
    case actions.SCREENING_UPDATE_FRONT_BACK_DOCUMENT:
      return {
        ...state,
        backPageDocument: action.value,
      }
    case actions.SCREENING_UPDATE_SELFIE:
      return {
        ...state,
        selfie: action.value,
      }
    case actions.SCREENING_UPDATE_SELECTED_DOCUMENT_TYPE:
      return {
        ...state,
        selectedDocType: action.value,
      }
    case actions.SCREENING_UPDATE_USER_INFROMATION:
      return {
        ...state,
        loading: true,
        warningMessage: '',
        screeningStatus: 'info',
        screeningResults: 'Loading wait...',
      }
    case actions.SCREENING_UPDATE_USER_INFROMATION_SUCCESS:
      return {
        ...state,
        loading: false,
        screeningStatus: 'success',
        screeningResults:
          'You have successfully completed the IDV screening process and the results will be updated in the application thanks!',
      }
    case actions.SCREENING_UPDATE_USER_INFROMATION_FAILURE:
      return {
        ...state,
        loading: false,
        screeningStatus: 'warning',
        screeningResults: 'Something is wrong!',
      }
    case actions.SCREENING_SEND_IDV_INVITATION_TO_VERIFY:
      return {
        ...state,
        loading: true,
      }
    case actions.SCREENING_SEND_IDV_INVITATION_TO_VERIFY_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case actions.SCREENING_SEND_IDV_INVITATION_TO_VERIFY_FAILURE:
      return {
        ...state,
        loading: false,
      }
    default:
      return state
  }
}
